module.exports = __webpack_public_path__ + "img/title.9a390db2.png";